import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';
// Custom packages - Component
import { DdtsListComponent } from 'src/app/modules/ddts/pages/ddts-list/ddts-list.page';
import { ChecklistDetailComponent } from './pages/checklist-detail/checklist-detail.page';
import { ChecklistListComponent } from './pages/checklist-list/checklist-list.page';
import { DdtDetailComponent } from './pages/ddt-detail/ddt-detail.page';
var ɵ0 = {
    permissions: ['canReadDocumentsList']
}, ɵ1 = {
    permissions: ['canCreateDocuments']
}, ɵ2 = {
    permissions: ['canReadDocumentsList']
}, ɵ3 = {
    permissions: ['canReadDocumentsList']
};
var routes = [
    {
        path: 'list',
        component: DdtsListComponent,
        canActivate: [RoleGuard],
        data: ɵ0,
    },
    {
        path: 'detail/:ddtId',
        component: DdtDetailComponent,
        canActivate: [RoleGuard],
        data: ɵ1,
    },
    {
        path: 'checklist',
        component: ChecklistListComponent,
        canActivate: [RoleGuard],
        data: ɵ2,
    },
    {
        path: 'checklist-detail/:ddtId',
        component: ChecklistDetailComponent,
        canActivate: [RoleGuard],
        data: ɵ3,
    },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var DdtsRoutingModule = /** @class */ (function () {
    function DdtsRoutingModule() {
    }
    return DdtsRoutingModule;
}());
export { DdtsRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3 };
